
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Layout from '../../../components/docs/Layout';
import Library from '../../../components/docs/Library';
export const metadata = {
  toc: true,
  layout: 'guide',
  description: 'Learn about libraries and SDKs to easily integrate with the Plaid APIs'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Header title='Libraries' subtitle={metadata.description} mdxType="Header" />
    <p>{`All libraries for Plaid are listed below. If you've built anything that you'd
be willing to share with the Plaid community, please let us know and we'll link
to it here!`}</p>
    <h4 {...{
      "id": "client-libraries"
    }}>{`Client libraries`}</h4>
    <p>{`Plaid offers official API libraries for different programming languages, which
are regularly updated for breaking and non-breaking API changes. These client libraries
are generated from our `}<a parentName="p" {...{
        "href": "https://github.com/plaid/plaid-openapi"
      }}>{`OpenAPI file`}</a>{`.`}</p>
    <Library imageSrc='/assets/img/icons/node.svg' width='64' height='64' name='Node' description='plaid-node' url='https://github.com/plaid/plaid-node' mdxType="Library" />
    <Library imageSrc='/assets/img/icons/python.svg' width='64' height='64' name='Python' description='plaid-python' url='https://github.com/plaid/plaid-python' mdxType="Library" />
    <Library imageSrc='/assets/img/icons/ruby.svg' width='64' height='64' name='Ruby' description='plaid-ruby' url='https://github.com/plaid/plaid-ruby' mdxType="Library" />
    <Library imageSrc='/assets/img/icons/java.svg' width='64' height='64' name='Java' description='plaid-java' url='https://github.com/plaid/plaid-java' mdxType="Library" />
    <Library imageSrc='/assets/img/icons/go-lang.svg' width='64' height='56.58' name='Go' description='plaid-go' url='https://github.com/plaid/plaid-go' mdxType="Library" />
    <Layout.Spacer units={5} />
    <h4 {...{
      "id": "community-libraries"
    }}>{`Community libraries`}</h4>
    <p>{`Explore some of the community-supported libraries available for Plaid listed below. If you built your own library,
please reach out to our `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/support/new"
      }}>{`support team`}</a>{` to add it to this list! The best way to create your own library is by using the `}<a parentName="p" {...{
        "href": "https://github.com/plaid/plaid-openapi"
      }}>{`Plaid OpenAPI file`}</a>{`.`}</p>
    <p>{`Note that community libraries are not officially supported by Plaid. Plaid cannot provide assistance with using these libraries or guarantee that they will be kept up-to-date with all the changes needed to support the latest modifications to the Plaid API.`}</p>
    <Library isCommunity={true} name='Elixir' description='by @tylerwray' url='https://github.com/tylerwray/elixir-plaid' mdxType="Library" />
    <Library isCommunity={true} name='Elixir' description='by @wfgilman' url='https://github.com/wfgilman/plaid-elixir' mdxType="Library" />
    <Library isCommunity={true} name='.NET' description='Going.Plaid, by @viceroypenguin' url='https://github.com/viceroypenguin/Going.Plaid' mdxType="Library" />
    <Library isCommunity={true} name='Node' description='plaid-fetch, by @heysanil. For Vercel Edge Runtime environments that don&apos;t support Axios middleware.' url='https://github.com/heysanil/plaid-fetch' mdxType="Library" />
    <Layout.Spacer units={5} />
    <h4 {...{
      "id": "link-client-sdks"
    }}>{`Link client SDKs`}</h4>
    <p>{`For information on Plaid's front-end SDKs for web and mobile, see `}<a parentName="p" {...{
        "href": "/docs/link/"
      }}>{`Link`}</a>{`.`}</p>
    <p>{`To learn more about installing and using Link SDKs, check out the docs pages for Link on `}<a parentName="p" {...{
        "href": "/docs/link/web"
      }}>{`JavaScript and React (web)`}</a>{`, `}<a parentName="p" {...{
        "href": "/docs/link/react-native/"
      }}>{`React Native`}</a>{`, `}<a parentName="p" {...{
        "href": "/docs/link/flutter/"
      }}>{`Flutter`}</a>{`, `}<a parentName="p" {...{
        "href": "/docs/link/ios"
      }}>{`iOS`}</a>{`, `}<a parentName="p" {...{
        "href": "/docs/link/android"
      }}>{`Android`}</a>{`, and `}<a parentName="p" {...{
        "href": "/docs/link/hosted-link"
      }}>{`Hosted Link`}</a>{`.`}</p>
    <p>{`Note that libraries marked as (community) are not officially supported by Plaid. Plaid cannot provide assistance with using these libraries or guarantee that they will be kept up-to-date with all the changes needed to support the latest modifications to the Plaid API.`}</p>
    <Library imageSrc='/assets/img/icons/ios.svg' name='iOS' description='plaid-link-ios' url='https://github.com/plaid/plaid-link-ios' mdxType="Library" />
    <Library imageSrc='/assets/img/icons/android.svg' name='Android' description='plaid-link-android' url='https://github.com/plaid/plaid-link-android' mdxType="Library" />
    <Library imageSrc='/assets/img/icons/react-lang.svg' name='React' description='react-plaid-link' url='https://github.com/plaid/react-plaid-link' width='64' height='45.25' mdxType="Library" />
    <Library imageSrc='/assets/img/icons/react-lang.svg' name='React Native' description='react-native-plaid-link-sdk' url='https://github.com/plaid/react-native-plaid-link-sdk' width='64' height='45.25' mdxType="Library" />
    <Library imageSrc='/assets/img/icons/flutter.svg' name='Flutter' description='plaid-link-flutter' url='https://github.com/plaid/plaid-link-flutter' width='64' height='64' mdxType="Library" />
    <Library name='JavaScript' description='Web' url='/docs/link/web' width='64' height='45.25' mdxType="Library" />
    <Library name='Vue' description='by Jeroen Claessens (community)' url='https://github.com/jclaessens97/vue-plaid-link' width='64' height='45.25' mdxType="Library" />
    <Library name='Flutter (mobile)' description='plaid_flutter, by @jorgefspereira (community)' url='https://github.com/jorgefspereira/plaid_flutter' width='64' height='45.25' mdxType="Library" />
    <Library name='Flutter Universal' description='Based on Flutter (mobile), adds Flutter Desktop support. By @maxintapp (community)' url='https://github.com/maxint-app/plaid_universal/' width='64' height='45.25' mdxType="Library" />
    <Library name='SolidJS' description='by @thedanchez (community)' url='https://github.com/dsnchz/solid-plaid-link' width='64' height='45.25' mdxType="Library" />
    <h4 {...{
      "id": "quickstart--example-apps"
    }}>{`Quickstart & example apps`}</h4>
    <p>{`For a listing of Plaid sample apps, see the `}<a parentName="p" {...{
        "href": "/docs/resources/#sample-apps"
      }}>{`Resources page`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "client-libraries",
        level: 4,
        title: "Client libraries",
      },
{
        id: "community-libraries",
        level: 4,
        title: "Community libraries",
      },
{
        id: "link-client-sdks",
        level: 4,
        title: "Link client SDKs",
      },
{
        id: "quickstart--example-apps",
        level: 4,
        title: "Quickstart & example apps",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
